import { Show, type JSX, type ParentProps } from "solid-js";
import { ButtonA } from "~/common/button";
import { Icon } from "~/icon";

// A numbered step on the customer's Twelve Link setup pages.
export function SetupStep(props: ParentProps<{ number: number; title: string }>) {
  return (
    <li class="rounded-xl border border-brand-border bg-white p-6">
      <div class="flex items-center gap-3">
        <span class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-brand-primary text-sm font-semibold text-white">
          {props.number}
        </span>
        <h2 class="font-semibold text-typography-primary">{props.title}</h2>
      </div>
      <div class="mt-2 pl-10">{props.children}</div>
    </li>
  );
}

// The first step: what to install where (children), and the installer once one is published.
export function DownloadStep(props: { href: string; available: boolean; children: JSX.Element }) {
  return (
    <SetupStep number={1} title="Download the installer">
      <p class="text-sm text-typography-secondary">{props.children}</p>
      <div class="mt-4">
        <Show
          when={props.available}
          fallback={
            <p class="text-sm text-typography-secondary">
              The installer isn't available yet. Check back shortly or contact your Twelve
              representative.
            </p>
          }
        >
          <ButtonA href={props.href} variant="primary">
            <Icon name="download" size="sm" />
            Download Twelve Link
          </ButtonA>
        </Show>
      </div>
    </SetupStep>
  );
}
